import React, { Component } from "react";
import {
  View,
  KeyboardAvoidingView,
  StyleSheet,
  BackHandler,
  Text,
} from "react-native";
import * as Permissions from "expo-permissions";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import ArTheme from "../argon-ui/Theme";
import { IconButton } from "./Buttons";
import { translate } from "../locales/translate";
import { ArButton } from "../argon-ui";
import Theme from "../argon-ui/Theme";

class QRScanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scanning: false,
      serverIp: null,
    };
  }
  async componentDidMount() {}
  showScanner = async () => {
    var hasPermission = await this.getPermissionAsync();
    if (hasPermission) {
      this.setState({ scanning: true }, () => {
        BackHandler.addEventListener("hardwareBackPress", this.cancelScanning);
      });
      typeof this.props.onScanning == "function" && this.props.onScanning(true);
    }
  };

  cancelScanning = () => {
    this.setState({ scanning: false }, () => {
      BackHandler.removeEventListener("hardwareBackPress", this.cancelScanning);
    });
    typeof this.props.onScanning == "function" && this.props.onScanning(false);
    return true;
  };

  getPermissionAsync = async () => {
    // const { status } = await BarCodeScanner.requestPermissionsAsync();
    // var permissionToGet =  Constants.platform.ios ? Permissions.CAMERA_ROLL : Permissions.CAMERA;
    let { status } = await Permissions.getAsync(Permissions.CAMERA);
    if (status == "granted") {
      return true;
    } else {
      let { status } = await Permissions.askAsync(Permissions.CAMERA);
      if (status == "granted") {
        return true;
      }
    }
    return false;
  };

  render() {
    return (
      <KeyboardAvoidingView>
        <View>
          <ArButton
            variant="outline"
            icon={faCharCodes.faBarcodeRead}
            iconColor={Theme.COLORS.PRIMARY}
            onPress={() => this.showScanner()}
            style={{ marginBottom: 0 }}
            isLoading={this.state.isSearching}
          >
            {translate("building.scanQRCode")}
          </ArButton>
          {/* <IconButton
            onPress={() => this.showScanner()}
            style={this.props.style || styles.btnAdd}
            icon={{
              code: faCharCodes.faBarcodeRead,
              style: {
                color: ArTheme.COLORS.TL_PURPLE,
                fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
                fontSize: this.props.fontSize || 20,
              },
            }}
            caption={
              this.state.isSearching
                ? {
                    text: this.state.searchPercent + "%",
                    style: { color: ArTheme.COLORS.TL_PURPLE },
                  }
                : undefined
            }
          /> */}
        </View>
      </KeyboardAvoidingView>
    );
  }
}
const styles = StyleSheet.create({
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#E0E0E0",
    borderColor: ArTheme.COLORS.TL_PURPLE_DARK,
    borderWidth: 0,
    // shadowColor: "#000",
    // shadowRadius: 5,
    // elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  scanContainer: { flex: 1, position: "relative" },
  overlay: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
  unfocusedContainer: { flex: 0.5, backgroundColor: "rgba(0,0,0,0.7)" },
  middleContainer: { flexDirection: "row", flex: 1.5 },
  focusedContainer: { flex: 9 },
  cancelButton: { position: "relative", bottom: 15, alignSelf: "center" },
});
export default QRScanner;
